'use strict';

// Meus Chamados Controller

var meusChamadosMdl = angular.module('meusChamadosMdl');
meusChamadosMdl.controller('meusChamadosCtrl', meusChamadosCtrl);

meusChamadosCtrl.$inject = [
    '$scope',
    '$filter',
    '$localStorage',
    'notificacao',
    'categorizacoesApi',
    'meusChamadosApi',
    'Event'
];

function meusChamadosCtrl(
    $scope,
    $filter,
    $localStorage,
    notificacao,
    categorizacoesApi,
    meusChamadosApi,
    Event) {

    var $ctrl = this;

    $ctrl.paginaAtual = 1;
    
    $ctrl.totalRegistrosEncontrados = 0;
    $ctrl.limiteMensagem = 130;

    $ctrl.buscarMeusChamados = _.debounce(buscarMeusChamados, 100);
    $ctrl.alternarTipoLista = alternarTipoLista;
    $ctrl.atualizarPagina = atualizarPagina;
    $ctrl.atualizar = atualizar;
    $ctrl.buscando = {};
    $ctrl.chamados = [];
    $ctrl.pesquisa = {};
    $ctrl.$storage = $localStorage.$default({
        tipoListaChamado: 'lista-visao-default',
        maximoRegistrosPorPagina: 5
    });
    $ctrl.maximoRegistrosPorPagina = $ctrl.$storage.maximoRegistrosPorPagina;

    categorizacoesApi.listarSituacoes(function (situacoes) {
        $ctrl.situacoes = situacoes;
    }, function (erros) {
        notificacao.erroResponse(erros);
    });

    categorizacoesApi.listarCanaisDeAtendimento(function (canaisDeAtendimento) {
        $ctrl.canaisDeAtendimento = canaisDeAtendimento;
    }, function (erros) {
        notificacao.erroResponse(erros);
    });

    $ctrl.buscarMeusChamados(1);

    Event.on('meus-chamados:atualizar', function(){
        $ctrl.buscarMeusChamados($ctrl.paginaAtual);
    })($scope)

    /**
     * @param int page
     */
    function buscarMeusChamados(page) {

        var parametros = _.merge(_.clone($ctrl.pesquisa), {
            pagina: page,
            maximoRegistrosPorPagina: $ctrl.maximoRegistrosPorPagina,
            dataInicio: normalizarData($ctrl.pesquisa.dataInicio),
            dataFim: normalizarData($ctrl.pesquisa.dataFim)
        });


        return $ctrl.buscando = meusChamadosApi.listarMeusChamados(_.omitBy(parametros, seNulo), function (resposta) {
            // Conta os anexo
            _.map(resposta.registrosEncontrados, function (registro) {
                registro.totalAnexo = _.sumBy(registro.contadorAnexos, 'quantidade');
            });
            
            $ctrl.chamados = resposta.registrosEncontrados;
            $ctrl.paginaAtual = resposta.pagina;
            $ctrl.totalRegistrosEncontrados = resposta.totalRegistrosEncontrados;
            $ctrl.maximoRegistrosPorPagina = resposta.maximoRegistrosPorPagina;

        }, function (erros) {

            $ctrl.chamados = [];
            $ctrl.paginaAtual = 1;
            $ctrl.totalRegistrosEncontrados = 0;

            notificacao.erroResponse(erros);
        }).$promise;

    }

    function atualizarPagina() {

        // Salva a quantidade de registros selecionado no historico
        $ctrl.$storage.maximoRegistrosPorPagina = $ctrl.maximoRegistrosPorPagina;

        $ctrl.buscarMeusChamados(1);
    }


    /**
     * Verifica se o valor é nulo
     */
    function seNulo(valor) {
        return !valor;
    }

    /**
     * Normaliza a data
     */
    function normalizarData(data) {
        return _.isDate(data) ? data.toISOString().slice(0, 10) : null;
    }

    /**
     * Define o tipo de apresentação dos 
     * segmentos.
     * 
     * @param string tipo
     */
    function alternarTipoLista() {

        if($ctrl.$storage.tipoListaChamado == 'lista-visao-alternativa01'){
            $ctrl.$storage.tipoListaChamado = 'lista-visao-default';
        } else {
            $ctrl.$storage.tipoListaChamado = 'lista-visao-alternativa01';
        }
        
    }

    /**
     * Atualiza a llista de chamados
     */
    function atualizar() {

        $ctrl.buscarMeusChamados($ctrl.paginaAtual).then(function () {
            notificacao.sucesso('Sua lista de chamados foi atualizada.');
        }, function (erros) {
            notificacao.erroResponse(erros);
        });

    };

}


// WEBPACK FOOTER //
// ./src/modules/meus-chamados/meus-chamados-controller.js